import React, { useEffect } from "react";

const Management = () => {
  return (
    <>
      <div className="management">
        <div className="management-title">
          Expert property management, with a <br /> heart for community.
        </div>
        <div className="management-detail-section">
          <div className="image-box"></div>
          <div className="detail-box">
            <div className="title-text">
              Authenticity in service brings the
              <br /> right clients to us.
            </div>
            <div className="sub-title">
              Exceptional community care is more than our passion — it's our
              purpose. At ABM, we go beyond management; we're a dedicated partner
              in building strong, thriving communities.
            </div>
            <div className="sub-title">
              We take pride in enhancing the lives of the residents we serve,
              collaborating with Boards of Directors to protect property values,
              uphold community integrity, and create a place homeowners are
              proud to call home. It's a privilege and a responsibility we
              approach with unwavering commitment.
            </div>
            <div className="sing-box">
              <img src="assets/img/alba-Monroy.png" alt="" />
              <div className="sign-text">President and CEO</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Management;
